import { render } from "./OfferedDetails.vue?vue&type=template&id=096f21af&ts=true"
import script from "./OfferedDetails.vue?vue&type=script&lang=ts"
export * from "./OfferedDetails.vue?vue&type=script&lang=ts"

import "./OfferedDetails.vue?vue&type=style&index=0&id=096f21af&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__